export default __webpack_public_path__ + "static/media/my-plan-manager.abc92ae1.svg";